<template>
	<TheForm
		:model="request"
		:rules="rules"
		:id="id"
		ref="formRef"
		:waiting="waiting"
		:showErr="showErr"
		:errMsg="texts.formErrors.pwResetFailed"
		:submitFunc="() => submitForm()"
	>
		<el-form-item label="E-Mail" prop="email">
			<el-input v-model="request.email" placeholder="E-Mail eingeben" />
		</el-form-item>

		<el-alert type="success" v-if="showSuccess" :closable="false">
			<template #title>
				<strong>Sie haben eine E-Mail erhalten</strong>
				<p>Bitte klicken Sie auf den Bestätigungslink in der E-Mail, um den Prozess abzuschließen. Bitte überprüfen Sie auch Ihren Spam-Ordner. </p>
			</template>
		</el-alert>
	</TheForm>

	<div class="button-panel">
		<TheButton @buttonclick="submitForm()" :loading="waiting" type="danger">Absenden</TheButton>
		<TheButton @buttonclick="$emit('cancel')" :loading="waiting" type="danger">Abbrechen</TheButton>
	</div>
</template>

<script lang="ts">
import { forgotPassword } from '@/requests/auth';
import { ForgotPasswordRequest } from '@/types/types';
import type { FormInstance } from 'element-plus';
import { defineComponent, ref } from 'vue';
import { useStore } from '../../store';
import { validateForm } from '../../utils/functions';
import { texts } from '../../utils/texts';
import TheButton from '../TheButton.vue';
import TheForm from '../TheForm.vue';

export default defineComponent({
	name: 'PasswordResetForm',
	setup() {
		const store = useStore();
		const formRef = ref<FormInstance>();
		return {
			store,
			formRef,
		};
	},
	data() {
		return {
			id: 'pwform',
			showErr: false,
			showSuccess: false,
			waiting: false,
			request: {
				email: '',
			},
			rules: {
				email: [
					{ required: true, message: texts.formErrors.emailReq, trigger: 'blur' },
					{ type: 'email', message: texts.formErrors.emailMissing, trigger: ['blur'] },
				],
			},
		};
	},
	emits: ['cancel'],
	components: {
		TheForm,
		TheButton,
	},
	computed: {
		texts() {
			return texts;
		},
	},
	methods: {
		async submitForm() {
			const isValid = await validateForm(this.formRef, this.id);
			if (!isValid) return;

			this.waiting = true;
			this.showErr = false;
			this.showSuccess = false;

			const result = await forgotPassword({
				email: this.request.email,
			} as ForgotPasswordRequest);
			if (result.success) {
				this.showSuccess = true;
			} else {
				this.showErr = true;
			}

			this.waiting = false;
		},
	},
});
</script>

<style lang="scss" scoped>
#pwform {
	p {
		margin: 0;
	}
}
</style>
